export default {
  PASSWORD: "Не меньше 8 и не больше 14 символов",
  LOGIN: "Не меньше 6 и не больше 30 символов",
};